export default {
  heroTitle: 'Se elprisen i realtid',
  heroSubtitle: 'Få overblik over de aktuelle spotpriser i dit område – opdateret hvert kvarter',
  introText: 'I Danmark handles el på Nord Pool-børsen, og prisen ændrer sig hvert kvarter. Med grafen nedenfor kan du se den aktuelle pris og planlægge dit forbrug, når strømmen er billigst. Vi tilbyder både time- og 15-minutters afregning.',
  readyToSave: 'Klar til at spare penge?',
  readyToSaveSubtitle: 'Få fordelagtige elpriser uden tillæg på spotprisen',
  
  // Price Chart
  currentPrice: 'Lige nu',
  lowestPrice: 'Laveste pris',
  highestPrice: 'Højeste pris',
  average: 'Gennemsnit',
  postalCode: 'Postnummer',
  postalCodePlaceholder: 'f.eks. 8000',
  supplier: 'Leverandør',
  noSuppliers: 'Ingen leverandører fundet',
  timePeriod: 'Tidsperiode',
  '15min': '15 Minutter',
  '1hour': '1 Time',
  loading: 'Henter data...',
  error: 'Fejl',
  noData: 'Ingen data tilgængelig.',
  vat: 'Moms',
  transportation: 'Transportation',
  elTax: 'Elafgift',
  reducedElTax: 'Reduceret Elafgift',
  basis: 'Basis',
  total: 'Total',
  note15min: 'Bemærk: 15-minutters afregning kræver smart elmåler. Kontakt os for at aktivere.',
};